import React from 'react';
import './RightSidebar.css';

const RightSidebar = ({ isOpen, onClose, onNavigate }) => {
  const navItems = [
    { name: 'About Us', key: 'about' },
    { name: 'Services', key: 'services' },
    { name: 'Designs', key: 'designs' },
    { name: 'Mobile Apps', key: 'mobileApps' },
    { name: 'Digital Marketing', key: 'digitalMarketing' },
    { name: 'Global Tie-ups', key: 'globalTieups' },
    { name: 'Contact Us', key: 'contact' }
  ];

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose}></div>}
      <div className={`right-sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h3>Navigation</h3>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        
        <nav className="nav-menu">
          {navItems.map((item, index) => (
            <div 
              key={index} 
              className="nav-item"
              onClick={() => onNavigate(item.key)}
            >
              <span className="nav-icon">▸</span>
              <span className="nav-text">{item.name}</span>
            </div>
          ))}
        </nav>
      </div>
    </>
  );
};

export default RightSidebar;
